/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from '@mui/material';
import SelectFormControl from '../../../../components/form-controls/SelectFormControl/SelectFormControl';

export const StyledActivitiesSelect = styled(SelectFormControl)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    maxWidth: '344px',
  },
  '.MuiSelect-icon': {
    top: 'calc(50% - .5em) !important',
  },
  '.Mui-disabled': {
    backgroundColor: theme.colors.primary100,
    color: theme.colors.grey500,
    '-webkit-text-fill-color': theme.colors.grey800,
  },
}));
